import {useLazyUserGetInfoQuery} from "./user-api";
import {useWorkflowIds} from "../../common/OrganizationConfig/useWorkflowIds";

export const useGetUserInfo = () => {
  const {getUserWorkflowId} = useWorkflowIds();

  const [trigger, result] = useLazyUserGetInfoQuery();

  const getUserInfo = () => {
    return trigger({workflowId: getUserWorkflowId});
  };

  return [getUserInfo, result] as const;
};
